import { render } from "./FinalConfirmModal.vue?vue&type=template&id=97ecf81c"
import script from "./FinalConfirmModal.vue?vue&type=script&lang=js"
export * from "./FinalConfirmModal.vue?vue&type=script&lang=js"

import exportComponent from "/www/wwwroot/plus.centrodeglaucoma.com/darmin-plus/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__